import CircularProgress from '@mui/material/CircularProgress';
import React, { useState, useEffect } from 'react';
import { ButtonComponent, CustomDatePicker, Nextsession ,TimePickerModal } from 'tutorapp-components';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { apiService } from '../utils/apiRequest';
import formatDateTime from '../utils/dateTimeService';
import { toast, ToastContainer } from 'react-toastify';
import { resetSessionData, setNextDate } from '../redux/actions/sessionActions';


const moment = require('moment-timezone');

export default function Nextsessionscreen() {
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [startTime, setStartTime] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Selected session card details for session creation
  const sessions = useSelector((state) => state.session);
  const userPreferences = useSelector((state) => state.userPreferences);
  const tutorid = useSelector((state) => state.franchise?.selectedFranchise?.tutor_id);
  const nextdate = sessions.nextdate;
  const duration = sessions.sessionDuration;
  // For calling create session report API
  const handleNextSession = () => {
    dispatch(setNextDate(formatDateTime(selectedDate, startTime)));
    createSession();
  };
  // For navigating back to session report page
  const handleBack = () => {
    navigate('/session-report');
  };
  // For skipping next session scheduling (when no hours left)
  const handleSkip = () => {
    createSession(true);
  };
  const handleTimeSelect = (selectedTime) => {
    setStartTime(selectedTime); // Expecting 24-hour format
  };
  const formattedNextSessionDateTime = selectedDate && startTime
    ? formatDateTime(selectedDate, startTime)
    : '';
  // Session payload data to be passed to create session report
  const newsessiondata = {
    appointment_id: sessions?.appointmentId,
    session_data: {
      session_date_time: sessions?.sessionDate,
      session_type: sessions?.sessionType,
      duration: sessions?.sessionDuration,
      practice_work_given: sessions?.practice_work_given,
      practice_work_given_detail: sessions?.practice_work_given_detail,
      notes: sessions?.notes,
      next_session_date_time: formattedNextSessionDateTime,
      submitted_by: tutorid,
    },
  };
  const parseDateString = (dateStr) => {
    if (!dateStr || !/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(dateStr)) {
      console.error('Invalid date string format:', dateStr);
      return null;
    }
    const [datePart, timePart] = dateStr.split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hour, minute, second] = timePart.split(':').map(Number);
    return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
  };
  const extractTime = (datetimeString) => {
    if (!datetimeString) {
      console.error('Invalid datetime string:', datetimeString);
      return null;
    }
    const match = datetimeString.match(/\d{4}-\d{2}-\d{2} (\d{2}:\d{2})(?::\d{2})?/);
    return match ? match[1] : null; // Return time in HH:MM format
  };
  const convertTimeFormat = (timeString, targetTimezone) => {
    if (!timeString) {
      console.error('Invalid time string:', timeString);
      return '';
    }
    const match = timeString.match(/^(\d{2}:\d{2})(?::\d{2})?$/);
    if (!match) {
      console.error('Invalid time format:', timeString);
      return timeString;
    }
    if (!moment.tz.zone(targetTimezone)) {
      console.error('Invalid timezone:', targetTimezone);
      return timeString;
    }
    const utcTime = moment.utc(timeString, 'HH:mm');
    return utcTime.tz(targetTimezone).format('HH:mm');
  };
  // Create session API function
  const createSession = async (skip = false) => {
    try {
      setLoading(true);
      const sessionPayload = {
        ...newsessiondata,
        session_data: {
          ...newsessiondata.session_data,
          next_session_date_time: skip ? null : formattedNextSessionDateTime,
        },
      };
      const createSessionReport = process.env.REACT_APP_API_URL + 'createSessionReport';
      const options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(sessionPayload),
      };
      const response = await apiService(createSessionReport, options);
      if (response.status === 'success') {
        dispatch(resetSessionData());
        navigate('/Myappointment');
      } else {
        toast.error(response.message || 'Something went wrong. Please try again.', {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: 'dark',
          style: { backgroundColor: '#D32F2F', color: '#fff', fontWeight: '500' },
        });
      }
    } catch (error) {
      console.error('Error while rescheduling appointment:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (nextdate) {
      const parsedDate = parseDateString(nextdate);
      const extractedTime = extractTime(nextdate);
      const convertedTime = convertTimeFormat(extractedTime, userPreferences?.timezone);
      setSelectedDate(parsedDate);
      setStartTime(convertedTime);
    }
  }, [nextdate, userPreferences?.timezone]);

  return (
    <>
      <Nextsession
        handlesessionback={handleBack}
        icons={{
          sessionappointment: './images/ic_back.svg',
          close: './images/ic_close.svg',
          progress: './images/ic_three.svg',
        }}
      />
      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '70vh' }}>
          <CircularProgress style={{ color: 'black' }} />
        </div>
      ) : (
        <>
          <div className="d-flex justify-content-center">
            <div className="mt-4">
              <label className="mb-1" style={{ color: '#0b1422', fontFamily: 'GT-Walsheim-Medium' }}>
                Start Date
              </label>
              <CustomDatePicker
                selectedDate={selectedDate}
                setSelectedDate={(date) => setSelectedDate(date)}
                userPreferences={userPreferences}
              />
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <div className="mt-4" style={{ width: '320px' }}>
              <label className="mb-1" style={{ color: '#0b1422', fontFamily: 'GT-Walsheim-Medium' }}>
                Start Time
              </label>
               
                <TimePickerModal
                  userPreferences={userPreferences}
                  defaultStartTime={startTime}
                  onTimeSelect={handleTimeSelect}
                 
                />
            </div>
          </div>
          <div className="position-fixed bottom-0 w-100 p-3 d-flex flex-column align-items-center gap-3">
            <div style={{ width: '340px', fontFamily: 'GT-Walsheim' }}>
              <ButtonComponent
                label="Continue"
                style={{ backgroundColor: 'black', padding: 12, fontFamily: 'GT-Walsheim' }}
                textStyle={{ color: 'white' }}
                onPress={handleNextSession}
              />
            </div>
            <div style={{ width: '340px' }}>
              <ButtonComponent
                label="Skip"
                style={{ backgroundColor: '#E9EDF1', padding: 12, fontFamily: 'GT-Walsheim' }}
                textStyle={{ color: 'black' }}
                onPress={handleSkip}
              />
            </div>
            <div style={{ width: '340px' }}>
              <ButtonComponent
                label="Back"
                style={{ backgroundColor: '#E9EDF1', padding: 12, fontFamily: 'GT-Walsheim' }}
                textStyle={{ color: 'black' }}
                onPress={handleBack}
              />
            </div>
          </div>
          <ToastContainer />
        </>
      )}
    </>
  );
}